import { LoadWrapper, PageLayout, UnavailableMessage } from '@anyx/shared-ui';

export const ErrorUnavailablePage = () => {
  return (
    <PageLayout withNavigation={false} loadingComponent={<LoadWrapper />}>
      <UnavailableMessage action="home" />
    </PageLayout>
  );
};
